export default "__VITE_ASSET__D0hfxxlY__"